// React
import { createContext } from "react";

// Stable actions (openAt, openFrom, close, bind): consumers never re-render when a menu opens
export const ContextMenuActionsContext = createContext(null);

// Which element the open menu belongs to (for aria-expanded on ActionMenuButton)
export const ContextMenuStateContext = createContext({ open: false, anchorEl: null });
